/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createEqualScalar } from '../../factoriesAny.js';
export var equalScalarDependencies = {
  typedDependencies: typedDependencies,
  createEqualScalar: createEqualScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesEqualScalar.generated.js
// module id = 24
// module chunks = 0